import { useEffect, useRef, useState } from "react";
import { DateFilterContainer } from "./index.styles";
import UI from "@mile-meeting/mile-ui";
import { DateRange, RangeKeyDict } from "react-date-range";
import { Range } from "react-date-range";
import { ko } from "date-fns/locale";
import { useToast } from "hook/useToast";

const DateFilter = ({
  onChange,
  startDate = new Date(),
  endDate = new Date(),
  minDate,
  maxDate,
  maxDurationInMonths,
}: {
  onChange?: (startDate: Date, endDate: Date) => void;
  startDate?: Date;
  endDate?: Date;
  minDate?: Date;
  maxDate?: Date;
  maxDurationInMonths?: number;
}) => {
  const { showToast } = useToast();
  const ref = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState<boolean>(false);
  const [state, setState] = useState<Range>({
      startDate: startDate,
      endDate: endDate,
      key: "selection",
  });

  const setToMidnight = (date: Date): Date => {
    date.setHours(0, 0, 0, 0);
    return date;
  };

  const isDateDifferenceExceedingMax = (start: Date, end: Date, maxDurationInMonths: number): boolean => {
    const yearDifference = end.getFullYear() - start.getFullYear();
    const monthDifference = end.getMonth() - start.getMonth();

    const totalMonthsDifference = yearDifference * 12 + monthDifference;

    return totalMonthsDifference > maxDurationInMonths;
  }

  useEffect(() => {
    const handler = (event: any) => {
      if (open && ref.current && !ref.current.contains(event.target)) {
        setOpen?.(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, [open]);
  
  return (
    <DateFilterContainer>
      <UI.Typography type="body01 normal" fontStyle="medium" color="var(--alias-color-label-normal)">
        조회 기간
      </UI.Typography>
      <div onFocus={() => setOpen(true)}>
        <UI.Input
          size="small"
          prefixIcon="calendar"
          placeholder="시작 일자"
          showPrefixIcon
          width={160}
          value={`${startDate.getFullYear()}. ${(startDate.getMonth() + 1).toString().padStart(2, "0")}. ${startDate.getDate().toString().padStart(2, "0")}`}
        />
      </div>
      <div style={{ width: 12, height: 1, backgroundColor: "var(--alias-color-label-normal)" }} />
      <div onFocus={() => setOpen(true)}>
        <UI.Input
          size="small"
          prefixIcon="calendar"
          placeholder="종료 일자"
          showPrefixIcon
          width={160}
          value={`${endDate.getFullYear()}. ${(endDate.getMonth() + 1).toString().padStart(2, "0")}. ${endDate.getDate().toString().padStart(2, "0")}`}
        />
      </div>
      <div
        ref={ref}
        className="calendar-modal"
        style={{
          display: open ? "block" : "none",
          position: "absolute",
          boxShadow: "var(--alias-style-shadow-strong)",
          backgroundColor: "white",
          zIndex: 100,
          width: 356,
          left: 74,
          top: 38,
        }}
      >
        <DateRange
          locale={ko}
          onChange={(date: RangeKeyDict) => {
            const start = date.selection.startDate;
            const end = date.selection.endDate;
            if (start && end) {
              if (maxDurationInMonths && isDateDifferenceExceedingMax(start, end, maxDurationInMonths)) {
                showToast("최대 조회 가능 기간을 초과했습니다. 기간을 다시 선택해 주세요", "warning");
              } else {
                setState(date.selection);
                onChange?.(setToMidnight(start), setToMidnight(end));
              }
            }
          }}
          ranges={[state]}
          minDate={minDate}
          maxDate={maxDate}
        />
      </div>
    </DateFilterContainer>
  );
};

export default DateFilter;
